<form name="navicanSampleForm" class="navican-form form-horizontal"
      [formGroup]="navicanSampleForm" novalidate autocomplete="off"
      (ngSubmit)="Submit(navicanSampleForm.value,navicanSampleForm.valid)">
  <div class="Flexbox__flex-1">
    <div class="navican-form-item Flexbox required">
      <label class="control-label navican-form-title"
             [ngClass]="{'required-text-color':navicanSampleForm['controls']['externalId']['invalid'] || (navicanSampleForm['controls']['externalId']['pristine'] && submitted)}">
        External Specimen ID:
      </label>
      <div class="navican-form-value">
        <input type="text" placeholder="External Specimen ID"
               formControlName="externalId" class="form-control" required id="externalId" name="externalId">
        <gen-invalid-tooltip [tooltipPlacement]="'top'"
                             [tooltipRequired]="(navicanSampleForm['controls']['externalId']['dirty'] && navicanSampleForm['controls']['externalId']['invalid']) || (navicanSampleForm['controls']['externalId']['pristine'] && submitted)"
                             [tooltipText]="'External Specimen ID is Required'"></gen-invalid-tooltip>
      </div>
    </div>
    <div class="navican-form-item Flexbox required">
      <label class="control-label navican-form-title"
             [ngClass]="{'required-text-color':navicanSampleForm['controls']['histopathology']['invalid'] || (navicanSampleForm['controls']['histopathology']['pristine'] && submitted)}">
        Histopathology:
      </label>
      <div class="navican-form-value">
        <p-autoComplete placeholder="Histopathology" inputId="histopathology" inputStyleClass="form-control"
                        [appendTo]="'body'"
                        [suggestions]="histopatologies" (completeMethod)="getHistopathologies($event)"
                        forceSelection="true"
                        formControlName="histopathology" name="histopathology" field="display">
        </p-autoComplete>
        <gen-invalid-tooltip [tooltipPlacement]="'top'"
                             [tooltipRequired]="(navicanSampleForm['controls']['histopathology']['dirty'] && navicanSampleForm['controls']['histopathology']['invalid']) || (navicanSampleForm['controls']['histopathology']['pristine'] && submitted)"
                             [tooltipText]="'Histopathology is Required'"></gen-invalid-tooltip>
      </div>
    </div>
    <div class="navican-form-item Flexbox ">
      <label class="control-label navican-form-title">
        Shipper ID:
      </label>
      <div class="navican-form-value">
        <input type="text" placeholder="Shipper ID"
               formControlName="shipperId" class="form-control" id="shipperId" name="shipperId">
      </div>
    </div>
    <div class="navican-form-item Flexbox required">
      <label class="control-label navican-form-title"
             [ngClass]="{'required-text-color':navicanSampleForm['controls']['site']['invalid'] || (navicanSampleForm['controls']['site']['pristine'] && submitted)}">
        Site Of The Tumor:
      </label>
      <div class="navican-form-value">
        <p-autoComplete placeholder="Site" inputId="site" inputStyleClass="form-control" [appendTo]="'body'"
                        [suggestions]="sites" (completeMethod)="getSites($event)" forceSelection="true"
                        formControlName="site" name="site" field="display" [minLength]="0">
        </p-autoComplete>
        <gen-invalid-tooltip [tooltipPlacement]="'top'"
                             [tooltipRequired]="(navicanSampleForm['controls']['site']['dirty'] && navicanSampleForm['controls']['site']['invalid']) || (navicanSampleForm['controls']['site']['pristine'] && submitted)"
                             [tooltipText]="'Site is Required'"></gen-invalid-tooltip>
      </div>
    </div>
    <div class="navican-form-item Flexbox required">
      <label class="control-label navican-form-title"
             [ngClass]="{'required-text-color':navicanSampleForm['controls']['collection']['controls']['method']['invalid'] || (navicanSampleForm['controls']['collection']['controls']['method']['pristine'] && submitted)}">
        Collection method:
      </label>
      <div class="navican-form-value" formGroupName="collection">
        <select class="form-control" [compareWith]="compareBy" formControlName="method"
                name="method" id="method" required>
          <option [ngValue]="null">- Not Selected -</option>
          <option *ngFor="let cm of testService.testInfoCollections.specimenCollections; trackBy: trackByFn"
                  [ngValue]="cm">{{cm.display}}
          </option>
        </select>
        <gen-invalid-tooltip [tooltipPlacement]="'top'"
                             [tooltipRequired]="(navicanSampleForm['controls']['collection']['controls']['method']['dirty'] && navicanSampleForm['controls']['collection']['controls']['method']['invalid']) || (navicanSampleForm['controls']['collection']['controls']['method']['pristine'] && submitted)"
                             [tooltipText]="'Collection method is Required'"></gen-invalid-tooltip>
      </div>
    </div>
    <div class="navican-form-item Flexbox required">
      <label class="control-label navican-form-title"
             [ngClass]="{'required-text-color':navicanSampleForm['controls']['collection']['controls']['collectedDateTime']['invalid'] || (navicanSampleForm['controls']['collection']['controls']['collectedDateTime']['pristine'] && submitted)}">
        Collection Date:
      </label>
      <div class="navican-form-value" formGroupName="collection">
        <p-calendar id="collectedDateTime" formControlName="collectedDateTime" name="collectedDateTime"
                    icon="icon__Calendar"
                    panelStyleClass="hide-month-nav"
                    [monthNavigator]="true" [yearNavigator]="true"
                    showButtonBar="true" inputStyleClass="form-control" [appendTo]="'body'" yearRange="1900:2100"
                    placeholder="Select date (e.g: 08 Feb 1974)"
                    [showIcon]="true" dateFormat="dd M yy" dataType="string" required>
        </p-calendar>
        <gen-invalid-tooltip [tooltipPlacement]="'top'"
                             [tooltipRequired]="(navicanSampleForm['controls']['collection']['controls']['collectedDateTime']['dirty'] && navicanSampleForm['controls']['collection']['controls']['collectedDateTime']['invalid']) || (navicanSampleForm['controls']['collection']['controls']['collectedDateTime']['pristine'] && submitted)"
                             [tooltipText]="'Collection Date is Required'"></gen-invalid-tooltip>
      </div>
    </div>
    <div class="navican-form-item Flexbox required">
      <label class="control-label navican-form-title"
             [ngClass]="{'required-text-color':navicanSampleForm['controls']['type']['invalid'] || (navicanSampleForm['controls']['type']['pristine'] && submitted)}">
        Specimen Type:
      </label>
      <div class="navican-form-value">
        <select required class="form-control" [compareWith]="compareBy" formControlName="type"
                name="type" id="type">
          <option [ngValue]="null">- Not Selected -</option>
          <option *ngFor="let cm of testService.testInfoCollections.specimenTypes; trackBy: trackByFn" [ngValue]="cm">
            {{cm.display}}
          </option>
        </select>
        <gen-invalid-tooltip [tooltipPlacement]="'top'"
                             [tooltipRequired]="((navicanSampleForm['controls']['type']['dirty']) || (navicanSampleForm['controls']['type']['pristine'] && submitted))
                             && navicanSampleForm['controls']['type']['invalid']"
                             [tooltipText]="'Specimen Type'"></gen-invalid-tooltip>
      </div>
    </div>
  </div>
  <div class="Flexbox__flex-1">
    <div class="navican-form-item Flexbox">
      <label class="control-label navican-form-title"
             [ngClass]="{'required-text-color':navicanSampleForm['controls']['tumorPercentage']['invalid'] || (navicanSampleForm['controls']['tumorPercentage']['pristine'] && submitted)}">
        Tumor percentage:
      </label>
      <div class="navican-form-value">
        <input placeholder="1 - 100 (%)" class="form-control" type="number"
               id="tumorPercentage" formControlName="tumorPercentage"
               name="tumorPercentage"/>
        <gen-invalid-tooltip [tooltipPlacement]="'top'"
                             [tooltipRequired]="(navicanSampleForm['controls']['tumorPercentage']['dirty'] && navicanSampleForm['controls']['tumorPercentage']['invalid'])"
                             [tooltipText]="'Tumor percentage should should be between: 1-100'"></gen-invalid-tooltip>
      </div>
    </div>
    <div class="navican-form-item Flexbox required">
      <label class="control-label navican-form-title"
             [ngClass]="{'required-text-color':navicanSampleForm['controls']['receivedTime']['invalid'] || (navicanSampleForm['controls']['receivedTime']['pristine'] && submitted)}">
        Sample Received Date:
      </label>
      <div class="navican-form-value">
        <p-calendar id="receivedTime" formControlName="receivedTime" name="receivedTime" [monthNavigator]="true"
                    icon="icon__Calendar"
                    panelStyleClass="hide-month-nav"
                    [yearNavigator]="true"
                    showButtonBar="true" inputStyleClass="form-control" [appendTo]="'body'"
                    placeholder="Select date (e.g: 08 Feb 1974)"
                    [showIcon]="true" dateFormat="dd M yy" yearRange="1900:2100" dataType="string" required>
        </p-calendar>
        <gen-invalid-tooltip [tooltipPlacement]="'top'"
                             [tooltipRequired]="((navicanSampleForm['controls']['receivedTime']['dirty'] )||(navicanSampleForm['controls']['receivedTime']['pristine'] && submitted))
                             && navicanSampleForm['controls']['receivedTime']['invalid']"
                             [tooltipText]="'Sample Received Date is Required'"></gen-invalid-tooltip>
      </div>
    </div>
    <div class="navican-form-item Flexbox ">
      <label class="control-label navican-form-title">
        <!--[ngClass]="{'required-text-color':navicanSampleForm['controls'].printer['invalid'] || (navicanSampleForm['controls'].printer['pristine'] && submitted)}">-->
        Printer:
      </label>
      <div class="navican-form-value">
        <select class="form-control" [compareWith]="compareBy" formControlName="printer"
                name="printer" id="printer">
          <option [ngValue]=null>- Not Selected -</option>
          <option *ngFor="let cm of testService.testInfoCollections.printers; trackBy: trackByFn" [ngValue]="cm">
            {{cm.display}}
          </option>
        </select>
        <!-- uncomment if need to be required -->
        <!--        <gen-invalid-tooltip [tooltipPlacement]="'top'"
                                     [tooltipRequired]="(navicanSampleForm['controls'].printer['dirty'] && navicanSampleForm['controls'].printer['invalid']) || (navicanSampleForm['controls'].printer['pristine'] && submitted)"
                                     [tooltipText]="'Printer is Required'"></gen-invalid-tooltip>-->
      </div>
    </div>
    <div class="navican-form-item Flexbox">
      <label class="control-label navican-form-title">
        Specimen Returned To Lab:
      </label>
      <div class="navican-form-value">
        <select class="form-control" formControlName="returned"
                name="returned" id="returned">
          <option [ngValue]="null">- Not Selected -</option>
          <option [ngValue]="true">Yes</option>
          <option [ngValue]="false">No</option>
        </select>
      </div>
    </div>
    <div class="navican-form-item Flexbox">
      <label class="control-label navican-form-title">
        Specimen Notes:
      </label>
      <div class="navican-form-value">
        <textarea rows="5" placeholder="Notes" class="form-control" name="returnNotes" formControlName="returnNotes"
                  id="returnNotes"></textarea>
      </div>
    </div>
  </div>
</form>
